"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var inStorePaymentStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography;
    return ({
        root: {},
        label: {
            fontSize: typography.fontMD,
            fontWeight: 600,
            lineHeight: '16px',
        },
    });
}, { name: 'Checkout4_InStorePayment' });
exports.default = inStorePaymentStyles;
